import { render, staticRenderFns } from "./SolicitationFormModule.vue?vue&type=template&id=c98b1a96&scoped=true"
import script from "./SolicitationFormModule.vue?vue&type=script&lang=js"
export * from "./SolicitationFormModule.vue?vue&type=script&lang=js"
import style0 from "./SolicitationFormModule.vue?vue&type=style&index=0&id=c98b1a96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c98b1a96",
  null
  
)

export default component.exports